import classNames from 'classnames';
import LineBreak from '../LineBreak';
import Button from '../Button';
import styles from './MainBanner.module.scss';
import reading from '../../images/reading.png';
import girlWithBook from '../../images/girl-with-book.png';
import decoration from '../../images/main-banner-decoration.png';
import decorationMobile from '../../images/main-banner-decoration-mobile.png';
import useScreenSize from '../../hooks/useScreenSize';
import Statistics from '../Statistics';
import useApp from '../../hooks/useApp';

function MainBanner() {
  const { isMobile, isTablet } = useScreenSize();
  const { globals } = useApp();

  const numberOfStudents = (globals?.numberOfStudents as number) || 10000;

  const renderH1 = () => (
    <h1>
      Aprenda a <strong>usar as telas</strong> ao invés de{' '}
      <strong>ser usado por elas!</strong>
    </h1>
  );

  const renderReading = () => (
    <img className={styles.reading} src={reading} alt="lendo" />
  );

  const renderDecoration = () => (
    <img
      className={styles.decoration}
      src={isMobile ? decorationMobile : decoration}
      alt="decoration reading"
    />
  );

  return (
    <div className={classNames(styles.container)}>
      <section>
        {isTablet && renderH1()}
        {!isTablet && renderReading()}
        <div className={styles.box}>
          <div className={styles.boxContent}>
            {!isTablet && renderH1()}
            {isTablet && renderReading()}
            <div className={styles.text}>
              <h2>Conheça o Uso Saudável das Telas</h2>
              <p>
                O projeto nasceu em 2021 e é desenvolvido pela startup Imersa
                Audiovisual que atua há mais de 8 anos no mercado de educação
              </p>
              {!isTablet && (
                <p className={styles.highlightText}>
                  Esse projeto tem o apoio
                  <LineBreak />
                  da SEDE-MG e da FAPEMIG
                </p>
              )}
            </div>
            <img
              className={styles.girlWithBook}
              src={girlWithBook}
              alt="girl with book"
            />
            <Button variant="secondary">Conheça nosso produtos</Button>
          </div>
          {isTablet && renderDecoration()}
        </div>
        {!isTablet && renderDecoration()}
      </section>

      <div className={styles.statistics}>
        <Statistics
          number={numberOfStudents?.toLocaleString('pt-BR')}
          description="crianças e adolescentes impactados"
          plusColor="#FFD341A0"
          numberColor="var(--color-medium-blue)"
          descriptionColor="var(--color-medium-blue)"
        />
      </div>
    </div>
  );
}

export default MainBanner;
